import appfolioLogo from 'icons/appfolio-logo.png';
import aptlyLogo from 'icons/aptly-logo.webp';
import buildiumLogo from 'icons/buildium-logo.svg?url';
import codeboxLogo from 'icons/codebox-logo.png';
import igloohomeLogo from 'icons/igloohome-logo.svg?url';
import outlookLogo from 'icons/outlook-calendar-logo.svg?url';
import rentvineLogo from 'icons/rentvine-logo.jpg';

import { IconName } from '@tallo/design-system';

export enum IntegrationCategory {
  CALENDARS = 'Calendars',
  PROPERTY_MANAGEMENT = 'Property management',
  PROPERTY_ACCESS = 'Property access',
}

export interface IntegrationTile {
  /** An imported brand image where we have one. */
  logo?: string;
  /** A brand mark that already lives in the icon registry, e.g. Google's. */
  logoIcon?: IconName;
  /** A wordmark rather than a square mark, so it gets the tile's full width. */
  wide?: boolean;
}

export interface IntegrationDefinition {
  id: string;
  name: string;
  category: IntegrationCategory;
  description: string;
  tile: IntegrationTile;
  /** Only integrations we actually support have a detail page and a working connect flow. */
  supported: boolean;
}

export const integrations: IntegrationDefinition[] = [
  {
    id: 'google-calendar',
    name: 'Google Calendar',
    category: IntegrationCategory.CALENDARS,
    description: 'Showings sync to your calendar in real time',
    tile: { logoIcon: 'g-calendar' },
    supported: true,
  },
  {
    id: 'outlook-calendar',
    name: 'Outlook Calendar',
    category: IntegrationCategory.CALENDARS,
    description: 'Sync showings with your Microsoft calendar',
    tile: { logo: outlookLogo },
    supported: false,
  },
  {
    id: 'aptly',
    name: 'Aptly',
    category: IntegrationCategory.PROPERTY_MANAGEMENT,
    description: 'Sync properties from your Aptly listing feed',
    tile: { logo: aptlyLogo },
    supported: true,
  },
  {
    id: 'buildium',
    name: 'Buildium',
    category: IntegrationCategory.PROPERTY_MANAGEMENT,
    description: 'Import properties and push leads to Buildium',
    tile: { logo: buildiumLogo },
    supported: false,
  },
  {
    id: 'appfolio',
    name: 'AppFolio',
    category: IntegrationCategory.PROPERTY_MANAGEMENT,
    description: 'Keep listings and availability in sync',
    tile: { logo: appfolioLogo },
    supported: false,
  },
  {
    id: 'rentvine',
    name: 'Rentvine',
    category: IntegrationCategory.PROPERTY_MANAGEMENT,
    description: 'Sync your Rentvine property portfolio',
    tile: { logo: rentvineLogo },
    supported: false,
  },
  {
    id: 'codebox',
    name: 'CodeBox',
    category: IntegrationCategory.PROPERTY_ACCESS,
    description: 'A fresh door code for every self-guided showing',
    tile: { logo: codeboxLogo, wide: true },
    supported: true,
  },
  {
    id: 'igloohome',
    name: 'Igloohome',
    category: IntegrationCategory.PROPERTY_ACCESS,
    description: 'Smart locks with time-bound access PINs',
    tile: { logo: igloohomeLogo },
    supported: false,
  },
];
